<template>
  <div class="master-sub" v-if="adminMemberSettingAccess()">
    <!--#region -- Modal ---->
    <b-modal centered :ok-title="`Save`" @ok="updateMember"
             :cancel-title="`Cancel`"
             ref="EditMemberModal" :title="`Edit GRO Member`"
             button-size="sm">
      <div class="header-col">
        <div>Site</div>
        <div>{{ memberObj.region }}</div>
      </div>
      <div class="header-col">
        <div>GULID</div>
        <div>{{ memberObj.name }}</div>
      </div>
      <div class="header-col mb-4">
        <div>Dept Name</div>
        <div>{{ memberObj.department }}</div>
      </div>
      <div class="border-bottom"></div>
      <div class="header-col mt-4 validate">
        <div>Site</div>
        <div>
          <b-form-select size="sm" v-model="memberObj.region" :options="region_options"
                         @change="regionChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col validate">
        <div>Manager</div>
        <div>
          <b-form-select size="sm" v-model="memberObj.manager" :options="manager_options"
                         @change="managerChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col validate">
        <div>HQ Sales</div>
        <div>
          <b-form-select size="sm" v-model="memberObj.hq_sales" :options="hq_sales_options"
                         @change="hqSalesChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col validate">
        <div>Role</div>
        <div>
          <b-form-select size="sm" v-model="memberObj.role" :options="role_options"
                         @change="roleChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col validate">
        <div>Func Leader</div>
        <div>
          <b-form-select size="sm" v-model="memberObj.func_leader" :options="func_leader_options"
                         @change="funcLeaderChanged">
          </b-form-select>
        </div>
      </div>
    </b-modal>

    <b-modal centered :ok-title="`Update`" @ok="updateISR"
             :cancel-title="`Close`"
             id="modal-lg" size="lg"
             ref="EditISRModal" :title="`Edit GRO User`"
             button-size="sm">
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="Selection"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(company_id)="data">
            <span>
              {{data.item.company_id}}
            </span>
          </template>

          <template #cell(region)="data">
            <span>
              {{data.item.region}}
            </span>
          </template>

          <template #cell(deptno)="data">
            <span>
              {{data.item.deptno}}
            </span>
          </template>

          <template #cell(department)="data">
            <span>
              {{data.item.department}}
            </span>
          </template>

          <template #cell(name)="data">
            <span>
              {{data.item.name}}
            </span>
          </template>

          <template #cell(select)="data">
            <input type="checkbox" v-model="data.item.select" value="">
          </template>

        </b-table>
      </div>
    </b-modal>

    <b-modal centered :ok-title="`Update`" @ok="updatePM"
             :cancel-title="`Close`"
             id="modal-lg" size="lg"
             ref="EditPMModal" :title="`Edit GRO SA`"
             button-size="sm">
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="Selection"
                 small filter="Escalation"
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(company_id)="data">
            <span>
              {{data.item.company_id}}
            </span>
          </template>

          <template #cell(region)="data">
            <span>
              {{data.item.region}}
            </span>
          </template>

          <template #cell(deptno)="data">
            <span>
              {{data.item.deptno}}
            </span>
          </template>

          <template #cell(department)="data">
            <span>
              {{data.item.department}}
            </span>
          </template>

          <template #cell(name)="data">
            <span>
              {{data.item.name}}
            </span>
          </template>

          <template #cell(select)="data">
            <input type="checkbox" v-model="data.item.select" value="">
          </template>

        </b-table>
      </div>
    </b-modal>

    <b-modal centered :ok-title="`Save`" @ok="updateSignFlow"
             :cancel-title="`Cancel`"
             ref="EditSignFlowModal" :title="`Edit NRE Sign Flow`"
             button-size="sm">
      <div class="header-col-wide mt-4 validate">
        <div>GRO SA</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.gro_sa" :options="NRESelection.gro_sa"
                         @change="grosaChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>ES PM</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.espm" :options="NRESelection.espm"
                         @change="espmChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>ES PM Leader Review</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.espm_leader" :options="NRESelection.espm_leader"
                         @change="espmleaderChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>HQ Sales Review</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.hq_sales" :options="NRESelection.hq_sales"
                         @change="hqsalesChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GRO SA Leader Review</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.gro_sa_leader" :options="NRESelection.gro_sa_leader"
                         @change="grosaleaderChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GRO RSM</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.gro_rsm" :options="NRESelection.gro_rsm"
                         @change="grorsmChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GRO Sales Director</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.gro_sales_director" :options="NRESelection.gro_sales_director"
                         @change="grosalesdirectorChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GRO Director Header</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.gro_director_header" :options="NRESelection.gro_director_header"
                         @change="grodirectorheaderChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GRO SA Leader Confirmation</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.gro_sa_leader_conf" :options="NRESelection.gro_sa_leader_conf"
                         @change="grosaleaderconfChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>HQ Sales Confirmation</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.hq_sales_conf" :options="NRESelection.hq_sales_conf"
                         @change="hqsalesconfChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>ES PM Kickoff</div>
        <div>
          <b-form-select size="sm" v-model="NREObj.espm_kickoff" :options="NRESelection.espm_kickoff"
                         @change="espmkickoffChanged">
          </b-form-select>
        </div>
      </div>
    </b-modal>

    <b-modal centered :ok-title="`Delete`" @ok="deleteRecord"
             :cancel-title="`Cancel`"
             :ok-variant="`danger`"
             ref="DeleteModal" :title="`Delete Confirm`"
             button-size="sm">
      <div>{{ deleteObj.warning }}</div>
    </b-modal>

    <b-modal centered :ok-title="`Delete`" @ok="deleteAssignRule"
             :cancel-title="`Cancel`"
             :ok-variant="`danger`"
             ref="DeleteAssignRuleModal" :title="`Delete Confirm`"
             button-size="sm">
      <div>Are you sure you want to delete this assign rule?</div>
    </b-modal>

    <b-modal centered :ok-title="`Save`" @ok="updateAssignRule" @hidden="emptyFtieAssignSetting"
             :cancel-title="`Cancel`"
             ref="EditFtieAssignModal" :title="ftie_assign_rule.action_type + ` FTIE Assign Rule`"
             button-size="sm">
      <div class="header-col-wide mt-4 validate">
        <div>SF company<span class="text-danger pl-1">*</span></div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.SF_COMPANY" :options="ftie_assign_options.sf_company_options"
                         @change="siteChanged">
          </b-form-select>
        </div>
        <div>SF Sales Territory</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.SF_SALES_TERRITORY" :options="ftie_assign_options.sf_sales_territory_options"
                         @change="siteChanged">
          </b-form-select>
        </div>
        <div>Industrial</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.INDUSTRIAL" :options="ftie_assign_options.industrial_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Vertical</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.VERTICAL" :options="ftie_assign_options.vertical_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>User Group</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.USER_GROUP" :options="ftie_assign_options.user_group_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Source</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.SF_SOURCE" :options="ftie_assign_options.source_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Request Type</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.SF_REQUEST_TYPE" :options="ftie_assign_options.request_type_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Issue Type</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.SF_ISSUE_TYPE" :options="ftie_assign_options.issue_type_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Customer</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.CUSTOMER" :options="ftie_assign_options.customer_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Device</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.DEVICE" :options="ftie_assign_options.device_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GRO Owner</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.GRO_SA" :options="ftie_assign_options.gro_sa_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Contact Sales</div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.CONTACT_SALES" :options="ftie_assign_options.contact_sales_options">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>SITE<span class="text-danger pl-1">*</span></div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.FTIE_SITE" :options="ftie_assign_options.site_options"
                         @change="siteChanged">
          </b-form-select>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GTC Owner<span class="text-danger pl-1">*</span></div>
        <div>
          <b-form-select size="sm" v-model="ftie_assign_rule.GTC_OWNER" :options="ftie_assign_options.gtc_owner_options">
          </b-form-select>
        </div>
      </div>
    </b-modal>
    <div v-if="adminMemberSettingAccess()">
      <router-view ref="child"
                   :searchedData="searchedData"
                   :member_options="member_options"
                   :department_options="department_options"
                   :manager_options="manager_options"
                   :group_options="group_options"
                   :RoleData="RoleData"
                   :ISRData="ISRData"
                   :gropm_options="gropm_options"
                   :GROData="GROData"
                   :SignFlowData="SignFlowData"
                   :FtieAssignRules="FtieAssignRules"
                   :table_show="table_show"
                   @editMemberModal="showEditMemberModal"
                   @editSelectionModal="showEditSelectionModal"
                   @editSignFlowModal="showEditSignFlowModal"
                   @editFtieAssignModal="showEditFtieAssignModal"
                   @deleteModal="showDeleteConfirmation"
                   @deleteAssignRuleModal="showAssignRuleDelete"
                   @loadSelections="load" />
    </div>
    <!--#endregion-->

  </div>
  <div v-else>
    <p> You don't have enough permission to access this page!</p>
  </div>
</template>
<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'admin',
    data() {
      return {
        function_name: 'Admin-Member Setting',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        authUrl: '',
        frontendUrl: '',
        fields: [
          { key: 'company_id', label: 'company_id', thClass: 'align-middle', sortable: false },
          { key: 'region', label: 'company_name', thClass: 'align-middle', sortable: false },
          { key: 'deptno', label: 'deptno', thClass: 'align-middle', sortable: true },
          { key: 'department', label: 'department_name', thClass: 'align-middle', sortable: true },
          { key: 'name', label: 'member_gulid', thClass: 'align-middle', sortable: true },
          { key: 'select', label: 'Select', thClass: 'align-middle', sortable: false }
        ],
        // userInfo: '',
        // userEmail: '',
        // userFunctions: [],
        // userRoles: [],
        // userSites: [],
        // GRO_options_default: '',
        // GRO_options: [{ value: '', text: '---Select One---' }],
        // GROText: '',
        GRO: '',
        manager_options: [],
        func_leader_options: [{ value: 'N', text: 'N' },
        { value: 'Y', text: 'Y' }],
        hq_sales_options: [{ value: 'NULL', text: 'NULL' }],
        role_options: [{ value: 'Viewer', text: 'Viewer' },
        { value: 'Assigner', text: 'Assigner' },
        { value: 'Escalation', text: 'Escalation' },
        { value: 'Owner', text: 'Owner' }],
        region_options: [],
        searchedData: [],

        member_options: [],
        member: '',
        department_options: [],
        department: '',

        table_show: false,
        deleteObj: {
          type: null,
          warning: null,
          no: null,
          department: null,
          GRO: null,
          head: null,
          child: []
        },

        selectObj: {
          head: null,
          child: [],
          GRO: null,
          company_id: null,
        },
        Selection: [],

        ISRData: [],
        GROData: [],
        gropm_options: [],
        RoleData: [],
        group_options: [{ value: 'ES PM Leader', text: 'ES PM Leader' },
        { value: 'Getac Sales Manager', text: 'Getac Sales Manager' },
        { value: 'GRO Manager', text: 'GRO Manager' },
        { value: 'GRO RSM Manager', text: 'GRO RSM Manager' },
        { value: 'GRO TOP Manager', text: 'GRO TOP Manager' },
        { value: 'Tech Leader', text: 'Tech Leader' }],

        SignFlowData: [],
        NRESelection: {
          gro_sa: [],
          espm: [],
          espm_leader: [{ value: 'power', text: 'power' }, { value: 'alex.lee', text: 'alex.lee' }],
          hq_sales: [],
          gro_sa_leader: [],
          gro_rsm: [],
          gro_sales_director: [],
          gro_director_header: [],
          gro_sa_leader_conf: [],
          hq_sales_conf: [],
          espm_kickoff: [],
        },

        NREObj: {
          no: null,
          GRO: null,
          gro_sa: null,
          espm: null,
          espm_leader: null,
          hq_sales: null,
          gro_sa_leader: null,
          gro_rsm: null,
          gro_sales_director: null,
          gro_director_header: null,
          gro_sa_leader_conf: null,
          hq_sales_conf: null,
          espm_kickoff: null,
        },

        memberObj: {
          action: null,
          no: null,
          company_id: null,
          name: null,
          region: null,
          email: null,
          func_leader: 'N',
          department: null,
          deptno: null,
          role: 'Viewer',
          manager: null,
          cc_manager_mail: null,
          hq_sales: null
        },

        site: [],
        dropdown: [],
        login_user_name: '',
        searching: false,
        pageDisabled: true,
        ftie_assign_options: {
          sf_company_options: [],
          sf_sales_territory_options: [],
          site_options: [],
          industrial_options: [],
          vertical_options: [],
          user_group_options: [],
          source_options: [],
          request_type_options: [],
          issue_type_options: [],
          customer_options: [],
          device_options: [],
          gro_sa_options: [],
          contact_sales_options: [],
          gtc_owner_options: [],
        },
        ftie_assign_rule: {
          "RULE_ID": null,
          "SF_COMPANY": null,
          "SF_SALES_TERRITORY": null,
          "FTIE_SITE": null,
          "INDUSTRIAL": null,
          "VERTICAL": null,
          "USER_GROUP": null,
          "SF_SOURCE": null,
          "SF_REQUEST_TYPE": null,
          "SF_ISSUE_TYPE": null,
          "CUSTOMER": null,
          "DEVICE": null,
          "GRO_SA": null,
          "CONTACT_SALES": null,
          "GTC_OWNER": null,
        },
        default_ftie_assign_rule: {
          "RULE_ID": null,
          "SF_COMPANY": null,
          "SF_SALES_TERRITORY": null,
          "FTIE_SITE": null,
          "INDUSTRIAL": null,
          "VERTICAL": null,
          "USER_GROUP": null,
          "SF_SOURCE": null,
          "SF_REQUEST_TYPE": null,
          "SF_ISSUE_TYPE": null,
          "CUSTOMER": null,
          "DEVICE": null,
          "GRO_SA": null,
          "CONTACT_SALES": null,
          "GTC_OWNER": null,
        },
        FtieAssignRules: [],
        delete_rule_id: null
      }
    },
    created() {
      let self = this;
      // self.getPage(null);
    },
    computed: {

    },
    methods: {
      adminMemberSettingAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
        ) {
          /*
          || (user_functions && _.indexOf(user_functions, 'Getac Sales Manager') > -1)
          || (user_functions && _.indexOf(user_functions, 'GRO TOP Manager') > -1)
*/
          console.log("Access to admin member setting!");
          return true
        }
        return false;
      },
      getPage(request_data) {
        let self = this;
        let url = self.$root.baseUrl + '/admin-member/setting/';
        console.log('####getPage######');
        var i;

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        if (self.table_show == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['admin_info_object']);
              selection = res['list_info_object'];
              if (res['disable_member_id_list']) {
                for (i = 0; i < searchedData.length; i++) {
                  if (res['disable_member_id_list'].includes(searchedData[i]['no'])) {
                    searchedData[i]['active_status'] = false;
                  }
                }
              }
              console.log(selection)
              //console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.table_show = true;
            if (self.table_show == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData
            var i;
            if (searchedData.length == 0) {
              self.table_show = false;
            }
            if (request_data['action'] == '') {
              self.department = request_data['department']
              if ($.isEmptyObject(selection)) {
                self.department_options = [{ value: '', text: '---Select All---' }];
                self.department = self.department_options[0].value;
                self.member_options = [];
                self.member = '';
              }
              else {
                if (self.department == '') {
                  var department_options_new = new Array();
                  department_options_new = [{ value: '', text: '---Select All---' }];
                  var department = _.uniq(selection.department).sort()
                  for (i = 0; i < department.length; i++) {
                    department_options_new.push({ value: department[i], text: department[i] })
                  }
                  self.department_options = department_options_new;
                  self.department = self.department_options[0].value;
                }
                var member = selection.gulid.sort()
                if (member.length == 0) {
                  self.member_options = [];
                  self.member = '';
                }
                else {
                  var member_options_new = new Array();
                  for (i = 0; i < member.length; i++) {
                    member_options_new.push({ value: member[i], text: member[i] })
                  }
                  self.member_options = member_options_new;
                  self.member = self.member_options[0].value;
                  let requestData = {
                    action: 'load_member',
                    name: self.member,
                    GRO: request_data['GRO']
                  }
                  self.load(requestData)
                }

              }
            }
            else if (request_data['action'] == 'delete' && !selection) {
              self.$message.warning('Failed to delete member');
            }
            else if (request_data['action'] == 'sync' && !selection) {
              self.$message.warning('Failed to sync account');
            }

          })
      },
      getISR(request_data) {
        let self = this;
        let url = self.$root.baseUrl + '/admin-member/setting-addisr/';
        console.log('####getISR######');
        var i;

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        if (self.table_show == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['groisr_info_object']);
              selection = JSON.parse(res['list_info_object']);
              console.log(selection)
              //console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.table_show = true;
            if (self.table_show == true) {
              eventHub.$emit('loading', false);
            }
            var i;
            if (request_data['action'] == 'load') {
              self.Selection = selection
              self.ISRData = searchedData
              if (self.department == '') {
                var temp = new Array();
                var department_options_new = new Array();
                department_options_new = [{ value: '', text: '---Select All---' }];
                for (i = 0; i < selection.length; i++) {
                  temp.push(selection[i].department)
                }
                temp = _.uniq(temp).sort()
                for (i = 0; i < temp.length; i++) {
                  department_options_new.push({ value: temp[i], text: temp[i] })
                }
                self.department_options = department_options_new
                self.department = self.department_options[0].value;
              }
            }
            else if (request_data['action'] == 'update' ||
              request_data['action'] == 'delete') {
              if (!selection) {
                self.$message.warning('Failed to save GRO ISR');
              }
              else {
                self.ISRData = searchedData
              }
            }

            if (selection.length) {
              var temp = new Array()
              var member_options_new = new Array();
              for (i = 0; i < selection.length; i++) {
                if (searchedData.findIndex(p => p.gro_isr === selection[i].name) == -1) {
                  temp.push(selection[i].name)
                }
              }
              temp = _.uniq(temp).sort()
              for (i = 0; i < temp.length; i++) {
                member_options_new.push({ value: temp[i], text: temp[i] })
              }
              self.member_options = member_options_new;
              self.member = self.member_options[0].value;
            }

          })
      },
      getGRO(request_data) {
        let self = this;
        let url = self.$root.baseUrl + '/admin-member/setting-addgro/';
        console.log('####getGRO######');
        var i;

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        if (self.table_show == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['gropm_info_object']);
              selection = JSON.parse(res['list_info_object']);
              console.log(selection)
              //console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.table_show = true;
            if (self.table_show == true) {
              eventHub.$emit('loading', false);
            }
            var i;
            if (searchedData.length == 0) {
              self.table_show = false
            }
            if (request_data['action'] == 'load') {
              // self.Selection = selection
              self.GROData = searchedData
              self.Selection = selection
              if (selection.length) {
                var temp = new Array();
                var gropm_options_new = new Array();
                for (i = 0; i < selection.length; i++) {
                  if (searchedData.findIndex(p => p.gro_pm === selection[i].name) == -1) {
                    temp.push(selection[i].name)
                  }
                }
                temp = _.uniq(temp).sort()
                for (i = 0; i < temp.length; i++) {
                  gropm_options_new.push({ value: temp[i], text: temp[i] })
                }
                self.gropm_options = gropm_options_new
              }
            }
            else if (request_data['action'] == 'update' ||
              request_data['action'] == 'delete') {
              if (!selection) {
                self.$message.warning('Failed to save GRO PM');
              }
              else {
                self.GROData = searchedData
              }
            }

          })
      },
      getNRE(request_data) {
        let self = this;
        let url = self.$root.baseUrl + '/admin-member/nre-signflow/';
        console.log('####getNRE######');
        var i;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        if (self.table_show == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['nre_info_object']);
              selection = res['list_info_object'];
              console.log(selection)
              //console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.table_show = true;
            if (self.table_show == true) {
              eventHub.$emit('loading', false);
            }
            var i;
            self.SignFlowData = searchedData
            if (!self.SignFlowData.length) {
              self.table_show = false;
            }
            if (request_data['action'] == 'add' || request_data['action'] == 'update' ||
              request_data['action'] == 'delete') {
              if (selection == 'duplicate') {
                self.$message.warning('NRE Sign Flow already exists');
              }
              if (!selection) {
                self.$message.warning('Failed to save NRE Sign Flow');
              }
            }
            else if (request_data['action'] == 'load' && selection.no.length) {
              // self.SignFlowData = searchedData
              // self.selection = selection;
              self.NREObj.GRO = request_data['GRO']
              var manager = _.uniq(selection.manager).sort()
              var member_options_new = new Array();
              var gro_director_header = new Array();
              var espm_kickoff = new Array()
              var hq_sales_conf = new Array()
              var gro_sa_leader_conf = new Array()
              var gro_sales_director = new Array()
              var gro_rsm = new Array()
              var gro_sa_leader = new Array()
              var hq_sales = new Array()
              var gro_sa = new Array()
              var espm = new Array()
              // var espm_leader = new Array()

              member_options_new = [{ value: '', text: '---Select All---' }];
              gro_sa_leader = [{ value: 'SKIP', text: 'SKIP' }];
              gro_sa_leader_conf = [{ value: 'SKIP', text: 'SKIP' }];
              hq_sales = [{ value: 'HQ Sales of Contact Sales', text: 'HQ Sales of Contact Sales' }];
              hq_sales_conf = [{ value: 'HQ Sales of Contact Sales', text: 'HQ Sales of Contact Sales' }];
              gro_rsm = [{ value: 'SKIP', text: 'SKIP' }];
              gro_rsm.push({ value: 'Ticket Contact Sales', text: 'Ticket Contact Sales' })
              gro_sales_director = [{ value: 'SKIP', text: 'SKIP' }];
              gro_sales_director.push({ value: 'Ticket Contact Sales Manager', text: 'Ticket Contact Sales Manager' })
              gro_director_header = [{ value: 'SKIP', text: 'SKIP' }];

              for (i = 0; i < selection.no.length; i++) {
                if (selection.region[i] === request_data['GRO'] && selection.manager[i] !== null && selection.manager[i] !== 'None' && selection.manager[i] !== '') {
                  gro_sales_director.push({ value: selection.manager[i], text: selection.manager[i] })
                  if (selection.role[i] != 'GRO RSM Manager') {
                    gro_director_header.push({ value: selection.manager[i], text: selection.manager[i] })
                    gro_sa_leader.push({ value: selection.name[i], text: selection.name[i] })
                    gro_sa_leader_conf.push({ value: selection.name[i], text: selection.name[i] })
                    gro_rsm.push({ value: selection.name[i], text: selection.name[i] })
                  }
                  if (selection.role[i] == 'Escalation') {
                    member_options_new.push({ value: selection.name[i], text: selection.name[i] })
                    gro_sa.push({ value: selection.name[i], text: selection.name[i] })
                  }
                  else if (selection.role[i] == 'Viewer') {
                    hq_sales.push({ value: selection.name[i], text: selection.name[i] })
                    hq_sales_conf.push({ value: selection.name[i], text: selection.name[i] })
                  }
                }
                else {
                  if (selection.role[i] == 'Owner') {
                    espm.push({ value: selection.name[i], text: selection.name[i] })
                    // espm_leader.push({ value: selection.manager[i], text: selection.manager[i] })
                    espm_kickoff.push({ value: selection.name[i], text: selection.name[i] })
                  }
                }
              }

              self.member_options = [...new Map(member_options_new.map(item => [item['value'], item])).values()];
              self.NRESelection.gro_sa = [...new Map(gro_sa.map(item => [item['value'], item])).values()];
              self.NRESelection.hq_sales = [...new Map(hq_sales.map(item => [item['value'], item])).values()];
              self.NRESelection.hq_sales_conf = [...new Map(hq_sales_conf.map(item => [item['value'], item])).values()];
              self.NRESelection.gro_sa_leader = [...new Map(gro_sa_leader.map(item => [item['value'], item])).values()];
              self.NRESelection.gro_sa_leader_conf = [...new Map(gro_sa_leader_conf.map(item => [item['value'], item])).values()];
              self.NRESelection.gro_rsm = [...new Map(gro_rsm.map(item => [item['value'], item])).values()];
              self.NRESelection.espm = [...new Map(espm.map(item => [item['value'], item])).values()];
              self.NRESelection.espm_kickoff = [...new Map(espm_kickoff.map(item => [item['value'], item])).values()];
              self.NRESelection.gro_sales_director = gro_sales_director.filter((thing, index, self) => self.findIndex(t => t.value === thing.value && t.text === thing.text) === index).sort(function (a, b) {
                if (a.value < b.value) {
                  return -1
                }
                if (a.value > b.value) {
                  return 1
                }
                return 0
              });
              self.NRESelection.gro_director_header = gro_director_header.filter((thing, index, self) => self.findIndex(t => t.value === thing.value && t.text === thing.text) === index).sort(function (a, b) {
                if (a.value < b.value) {
                  return -1
                }
                if (a.value > b.value) {
                  return 1
                }
                return 0
              });
            }
          })
      },
      getRole(request_data) {
        let self = this;
        let url = self.$root.baseUrl + '/admin-member/manager-group/';
        console.log('####getRole######');
        var i;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        if (self.table_show == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['role_info_object']);
              selection = res['list_info_object'];
              console.log("getRole - selection")
              console.log(selection)
              //console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.table_show = true;
            if (self.table_show == true) {
              eventHub.$emit('loading', false);
            }
            var i;
            self.RoleData = searchedData
            if (!self.RoleData.length) {
              self.table_show = false;
            }
            if (request_data['action'] == 'load') {
              var name = selection.name
              var member_options_new = new Array();
              var manager_options_new = new Array();
              if (selection.name.length) {
                member_options_new = [{ value: 'ALL', text: 'ALL' }];
                for (i = 0; i < name.length; i++) {
                  member_options_new.push({ value: name[i], text: name[i] })
                  manager_options_new.push({ value: name[i], text: name[i] })
                }
              }
              self.member_options = member_options_new
              self.manager_options = manager_options_new
            }
            else if (request_data['action'] == 'add' || request_data['action'] == 'delete') {
              if (selection == 'duplicate') {
                self.$message.warning('Role Setting already exits');
              }
              else if (!selection) {
                self.$message.warning('Failed to save Role Setting');
              }
            }
          })
      },
      refresh() {
        this.department = '';
        let request_data = {
          action: '',
          GRO: this.GRO,
          department: this.department
        };
        this.getPage(request_data)
      },
      showDeleteConfirmation(type, item, department) {
        let self = this;
        self.deleteObj.type = type
        if (type == 'member') {
          self.deleteObj.no = item.no
          self.deleteObj.GRO = item.site
          self.deleteObj.department = department
          self.deleteObj.warning = "Are you sure you want to delete this member?"
        }
        else if (type == 'groisr') {
          self.deleteObj.head = item.gro_isr
          self.deleteObj.warning = "Are you sure you want to delete this GRO ISR?"
        }
        else if (type == 'gropm') {
          self.deleteObj.head = item.gro_pm
          self.deleteObj.GRO = item.company_name
          self.deleteObj.warning = "Are you sure you want to delete this GRO PM?"
        }
        else if (type == 'nre') {
          self.deleteObj.department = department
          self.deleteObj.GRO = item.gro
          self.deleteObj.no = item.uni_id
          self.deleteObj.warning = "Are you sure you want to delete this sign flow?"
        }
        else if (type == 'role') {
          self.deleteObj.GRO = item.gro
          self.deleteObj.no = item.uni_id
          self.deleteObj.warning = "Are you sure you want to delete this role setting?"
        }
        self.$refs['DeleteModal'].show();
      },
      showAssignRuleDelete(item) {
        let self = this;
        self.delete_rule_id = item.RULE_ID;
        self.$refs['DeleteAssignRuleModal'].show();
      },
      deleteRecord(bvModalEvt) {
        let self = this;
        console.log('####deleteRecord######');
        bvModalEvt.preventDefault();
        if (self.deleteObj.type == 'member') {
          let request_data = {
            no: self.deleteObj.no,
            GRO: self.deleteObj.GRO,
            action: 'delete',
            department: self.department
          };
          console.log(request_data)
          self.getPage(request_data)
        }
        else if (self.deleteObj.type == 'groisr') {
          let request_data = {
            gro_isr: self.deleteObj.head,
            action: 'delete',
          };
          console.log(request_data)
          self.getISR(request_data)
        }
        else if (self.deleteObj.type == 'gropm') {
          let request_data = {
            gro_pm: self.deleteObj.head,
            GRO: self.deleteObj.GRO,
            action: 'delete',
          };
          console.log(request_data)
          self.getGRO(request_data)
        }
        else if (self.deleteObj.type == 'nre') {
          let request_data = {
            no: self.deleteObj.no,
            GRO: self.deleteObj.GRO,
            action: 'delete',
          };
          console.log(request_data)
          self.getNRE(request_data)
        }
        else if (self.deleteObj.type == 'role') {
          let request_data = {
            no: self.deleteObj.no,
            GRO: self.deleteObj.GRO,
            action: 'delete',
          };
          console.log(request_data)
          self.getRole(request_data)
        }
        else if (self.deleteObj.type == 'assign') {
          let request_data = {
            no: self.deleteObj.no,
            GRO: self.deleteObj.GRO,
            action: 'delete',
          };
          console.log(request_data)
          self.getRole(request_data)
        }


        self.$nextTick(() => {
          self.$refs['DeleteModal'].hide();
        })
      },
      showEditSelectionModal(item, type) {
        let self = this;
        var children = new Array()
        console.log(self.Selection)
        self.Selection = self.Selection.map((p) => ({
          ...p,
          select: false,
        }));
        if (type == 'gropm') {
          if (typeof item == 'string') {
            self.selectObj.head = item
          }
          else {
            self.selectObj.head = item.gro_pm
            for (var i = 0; i < item.gro_sa.length; i++) {
              children.push(item.gro_sa[i])
              if (self.Selection.findIndex(p => p.name === item.gro_sa[i]) != -1) {
                self.Selection[self.Selection.findIndex(p => p.name === item.gro_sa[i])].select = true
              }
            }
          }
          self.selectObj.GRO = self.Selection[0].region
          self.selectObj.company_id = self.Selection[0].company_id
          self.selectObj.child = children;
          self.$refs['EditPMModal'].show();
        }
        else {
          if (typeof item == 'string') {
            self.selectObj.head = item
          }
          else {
            self.selectObj.head = item.gro_isr
            for (var i = 0; i < item.gro_user.length; i++) {
              children.push(item.gro_user[i])
              if (self.Selection.findIndex(p => p.name === item.gro_user[i]) != -1) {
                self.Selection[self.Selection.findIndex(p => p.name === item.gro_user[i])].select = true
              }
            }
          }
          self.selectObj.child = children;
          self.$refs['EditISRModal'].show();
        }
      },
      updateISR(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();

        var array = new Array()
        var i;
        for (i = 0; i < self.Selection.length; i++) {
          if (self.Selection[i].select) {
            array.push(self.Selection[i].name)
          }
        }
        var gro_user = new Array()
        for (i = 0; i < self.selectObj.child.length; i++) {
          if (array.includes(self.selectObj.child[i])) {
            array.splice(array.indexOf(self.selectObj.child[i]), 1)
          }
          else {
            gro_user.push(self.selectObj.child[i])
          }
        }
        self.selectObj.child = array
        self.deleteObj.child = gro_user;
        console.log(self.selectObj.child)
        console.log(self.deleteObj.child)
        let request_data = {
          action: 'update',
          gro_isr: self.selectObj.head,
          gro_user: self.selectObj.child,
          delete: self.deleteObj.child,
          create_date: self.$root.getTime(),
        }
        self.getISR(request_data);

        self.$nextTick(() => {
          self.$refs['EditISRModal'].hide();
          let request_data = {
            action: 'load',
            department: '',
          };
          self.getISR(request_data);
        })
      },
      updatePM(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();

        var array = new Array()
        var i;
        for (i = 0; i < self.Selection.length; i++) {
          if (self.Selection[i].select && self.Selection[i].role == 'Escalation') {
            array.push(self.Selection[i].name)
          }
        }
        var gro_sa = new Array()
        for (i = 0; i < self.selectObj.child.length; i++) {
          // console.log(self.Selection.findIndex(p => p.name === self.selectObj.child[i]))
          if (array.includes(self.selectObj.child[i])) {
            array.splice(array.indexOf(self.selectObj.child[i]), 1)
          }
          else if (self.Selection.findIndex(p => p.name === self.selectObj.child[i]) != -1) {
            gro_sa.push(self.selectObj.child[i])
          }
        }
        self.selectObj.child = array
        self.deleteObj.child = gro_sa;
        console.log(self.selectObj.child)
        console.log(self.deleteObj.child)
        let request_data = {
          action: 'update',
          GRO: self.selectObj.GRO,
          company_id: self.selectObj.company_id,
          gro_pm: self.selectObj.head,
          gro_sa: self.selectObj.child,
          delete: self.deleteObj.child,
          create_date: self.$root.getTime(),
        }
        self.getGRO(request_data);

        self.$nextTick(() => {
          self.$refs['EditPMModal'].hide();
          let request_data = {
            action: 'load',
            GRO: self.selectObj.GRO,
          };
          self.getGRO(request_data);
        })
      },
      showEditSignFlowModal(item) {
        let self = this;
        if (typeof item == 'string') {
          self.NREObj.no = 0
          self.NREObj.espm = self.NRESelection.espm[0].value
          self.NREObj.espm_leader = self.NRESelection.espm_leader[0].value
          self.NREObj.hq_sales = self.NRESelection.hq_sales[0].value
          self.NREObj.gro_sa_leader = self.NRESelection.gro_sa_leader[0].value
          self.NREObj.gro_rsm = self.NRESelection.gro_rsm[0].value
          self.NREObj.gro_sales_director = self.NRESelection.gro_sales_director[0].value
          self.NREObj.gro_director_header = self.NRESelection.gro_director_header[0].value
          self.NREObj.gro_sa_leader_conf = self.NRESelection.gro_sa_leader_conf[0].value
          self.NREObj.hq_sales_conf = self.NRESelection.hq_sales_conf[0].value
          self.NREObj.espm_kickoff = self.NRESelection.espm_kickoff[0].value
          if (item == '') {
            if (self.NRESelection.gro_sa.length) {
              self.NREObj.gro_sa = self.NRESelection.gro_sa[0].value
              self.$refs['EditSignFlowModal'].show();
            }
            else {
              self.$message.warning('Missing selections');
            }
          }
          else {
            self.NREObj.gro_sa = item
            self.$refs['EditSignFlowModal'].show();
          }
        }
        else {
          self.NREObj.no = item.uni_id
          self.NREObj.GRO = item.gro
          self.NREObj.gro_sa = item.gro_sa
          self.NREObj.espm = item.espm
          self.NREObj.espm_leader = item.espm_leader
          self.NREObj.hq_sales = item.hq_sales
          self.NREObj.gro_sa_leader = item.gro_sa_leader
          self.NREObj.gro_rsm = item.gro_rsm
          self.NREObj.gro_sales_director = item.gro_sales_director
          self.NREObj.gro_director_header = item.gro_director_header
          self.NREObj.gro_sa_leader_conf = item.gro_sa_leader_conf
          self.NREObj.hq_sales_conf = item.hq_sales_conf
          self.NREObj.espm_kickoff = item.espm_kickoff
          self.$refs['EditSignFlowModal'].show();
        }
      },
      updateSignFlow(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let nreSignFlowColumn = ['gro_sa', 'espm', 'espm_leader', 'hq_sales', 'gro_sa_leader', 'gro_rsm', 'gro_sales_director','gro_director_header', 'gro_sa_leader_conf', 'hq_sales_conf', 'espm_kickoff'];
        var i;
        for (i = 0; i < nreSignFlowColumn.length; i++) {
          if (_.get(self.NREObj, nreSignFlowColumn[i], null) === 'None' || _.get(self.NREObj, nreSignFlowColumn[i], null) === null) {
            console.log("None happen in nre sign flow");
          }
        }

        if (self.NREObj.no == 0) {
          let request_data = {
            action: 'add',
            GRO: self.NREObj.GRO,
            gro_sa: self.NREObj.gro_sa,
            espm: self.NREObj.espm,
            espm_leader: self.NREObj.espm_leader,
            hq_sales: self.NREObj.hq_sales,
            gro_sa_leader: self.NREObj.gro_sa_leader,
            gro_rsm: self.NREObj.gro_rsm,
            gro_sales_director: self.NREObj.gro_sales_director,
            gro_director_header: self.NREObj.gro_director_header,
            gro_sa_leader_conf: self.NREObj.gro_sa_leader_conf,
            hq_sales_conf: self.NREObj.hq_sales_conf,
            espm_kickoff: self.NREObj.espm_kickoff
          }
          self.getNRE(request_data)
        }
        else {
          let request_data = {
            action: 'update',
            no: self.NREObj.no,
            GRO: self.NREObj.GRO,
            gro_sa: self.NREObj.gro_sa,
            espm: self.NREObj.espm,
            espm_leader: self.NREObj.espm_leader,
            hq_sales: self.NREObj.hq_sales,
            gro_sa_leader: self.NREObj.gro_sa_leader,
            gro_rsm: self.NREObj.gro_rsm,
            gro_sales_director: self.NREObj.gro_sales_director,
            gro_director_header: self.NREObj.gro_director_header,
            gro_sa_leader_conf: self.NREObj.gro_sa_leader_conf,
            hq_sales_conf: self.NREObj.hq_sales_conf,
            espm_kickoff: self.NREObj.espm_kickoff
          }
          self.getNRE(request_data)
        }

        self.$nextTick(() => {
          self.$refs['EditSignFlowModal'].hide();
        })
      },
      showEditMemberModal(item) {
        let self = this;
        // let isNew = _.isNil(item);
        if (typeof item == 'string') {
          if (item == '') {
            self.$message.warning('Missing selections');
          }
          else {
            self.memberObj.action = 'add'
            self.memberObj.name = item
            self.memberObj.hq_sales = ''
            self.memberObj.manager = ''
            self.memberObj.cc_manager_mail = '';
            self.$refs['EditMemberModal'].show();
          }
        }
        else {
          self.memberObj.action = 'update'
          self.memberObj.no = item.no
          self.memberObj.name = item.name
          self.memberObj.department = item.department
          self.memberObj.role = item.role
          self.memberObj.func_leader = item.func_leader
          self.memberObj.hq_sales = item.hq_sales
          self.memberObj.manager = item.manager
          self.memberObj.cc_manager_mail = item.cc_manager_mail
          self.memberObj.region = item.site
          self.GRO = item.site;
          self.$refs['EditMemberModal'].show();
        }
      },
      saveMemberToServer(action) {
        let self = this;
        if (action == 'add') {
          let request_data = {
            action: action,
            company_id: self.memberObj.company_id,
            name: self.memberObj.name,
            email: self.memberObj.email,
            func_leader: self.memberObj.func_leader,
            create_date: self.$root.getTime(),
            department: self.memberObj.department,
            deptno: self.memberObj.deptno,
            GRO: self.memberObj.region,
            role: self.memberObj.role,
            cc_manager_mail: self.memberObj.cc_manager_mail,
            manager: self.memberObj.manager,
            hq_sales: self.memberObj.hq_sales
          }
          self.load(request_data)
        }
        else {
          let request_data = {
            action: action,
            no: self.memberObj.no,
            site: self.memberObj.region,
            func_leader: self.memberObj.func_leader,
            role: self.memberObj.role,
            cc_manager_mail: self.memberObj.cc_manager_mail,
            manager: self.memberObj.manager,
            hq_sales: self.memberObj.hq_sales,
            company_id: self.memberObj.company_id
          }
          self.load(request_data)
        }
      },
      updateMember(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        switch (self.memberObj.action) {
          case 'add':
            self.saveMemberToServer('add');
            break;
          case 'update':
            self.saveMemberToServer('update');
            break;
          default:
        }

        self.$nextTick(() => {
          self.$refs['EditMemberModal'].hide();
          self.refresh();
        })
      },
      load(request_data) {
        let self = this;
        let url = self.$root.baseUrl + '/admin-member/setting/';
        console.log('####LoadSelection######');
        var i;

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let selection = [];
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = res['admin_info_object'];
              selection = res['list_info_object'];
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            var i;

            if (request_data['action'] == 'load_selection') {
              self.dropdown = selection;
              self.site = searchedData;
              var manager_options_new = new Array()
              var hq_sales_options_new = new Array();
              manager_options_new = [{ value: '', text: '' }];
              hq_sales_options_new = [{ value: '', text: '' }];
              var name = selection.name
              for (i = 0; i < name.length; i++) {
                manager_options_new.push({ value: name[i], text: name[i] })
                hq_sales_options_new.push({ value: name[i], text: name[i] })
              }
              self.manager_options = manager_options_new
              self.hq_sales_options = hq_sales_options_new;
              var region_options_new = new Array()
              var region = searchedData.region
              for (i = 0; i < region.length; i++) {
                region_options_new.push({ value: region[i], text: region[i] })
              }
              self.region_options = region_options_new;
              self.memberObj.region = selection.gro[0]
              self.memberObj.company_id = selection.company_id[0]
              self.GRO = selection.gro[0]
            }
            else if (request_data['action'] == 'load_member') {
              self.memberObj.name = selection.name[0]
              self.memberObj.email = selection.email[0]
              self.memberObj.department = selection.department[0]
              self.memberObj.deptno = selection.deptno[0]
              self.memberObj.region = selection.gro[0]
              self.member = request_data['name']
              self.GRO = selection.gro[0]
            }
            else if (request_data['action'] == 'add' && !selection) {
              self.$message.warning('Failed to add member');
            }
            else if (request_data['action'] == 'update' && !selection) {
              self.$message.warning('Failed to edit member');
            }
          })
      },
      regionChanged(region) {
        this.memberObj.region = region
        this.memberObj.company_id = this.site.company_id[this.site.region.indexOf(region)]
      },
      managerChanged(manager) {
        this.memberObj.manager = manager
        if (manager == '') {
          this.memberObj.cc_manager_mail = ''
        }
        else {
          this.memberObj.cc_manager_mail = this.dropdown.email[this.dropdown.name.indexOf(manager)]
        }
      },
      funcLeaderChanged(func_leader) {
        this.memberObj.func_leader = func_leader
      },
      hqSalesChanged(hq_sales) {
        this.memberObj.hq_sales = hq_sales
      },
      roleChanged(role) {
        this.memberObj.role = role
      },
      grosaChanged(gro_sa) {
        this.NREObj.gro_sa = gro_sa
      },
      espmChanged(espm) {
        this.NREObj.espm = espm
      },
      espmleaderChanged(espm_leader) {
        this.NREObj.espm_leader = espm_leader
      },
      hqsalesChanged(hq_sales) {
        this.NREObj.hq_sales = hq_sales
      },
      grosaleaderChanged(gro_sa_leader) {
        this.NREObj.gro_sa_leader = gro_sa_leader
      },
      grorsmChanged(gro_rsm) {
        this.NREObj.gro_rsm = gro_rsm
      },
      grosalesdirectorChanged(gro_sales_director) {
        this.NREObj.gro_sales_director = gro_sales_director
      },
      grodirectorheaderChanged(gro_director_header) {
        this.NREObj.gro_director_header = gro_director_header
      },
      grosaleaderconfChanged(gro_sa_leader_conf) {
        this.NREObj.gro_sa_leader_conf = gro_sa_leader_conf
      },
      hqsalesconfChanged(hq_sales_conf) {
        this.NREObj.hq_sales_conf = hq_sales_conf
      },
      espmkickoffChanged(espm_kickoff) {
        this.NREObj.espm_kickoff = espm_kickoff
      },
      siteChanged(site) {
        let self = this;
        if (self.ftie_assign_rule.FTIE_SITE && self.ftie_assign_rule.FTIE_SITE !== 'IGNORE') {
          //call API to get some option
          self.getFtieAssignOptionsBasedOnSite(self.ftie_assign_rule.FTIE_SITE);
        }
      },
      emptyFtieAssignSetting() {
        let self = this;
        self.ftie_assign_rule = JSON.parse(JSON.stringify(self.default_ftie_assign_rule));
        self.ftie_assign_options.customer_options = [{ 'value': null, 'text': 'IGNORED' }];
        self.ftie_assign_options.gro_sa_options = [{ 'value': null, 'text': 'IGNORED' }];
        self.ftie_assign_options.contact_sales_options = [{ 'value': null, 'text': 'IGNORED' }];
      },
      showEditFtieAssignModal(default_obj, action_type) {
        let self = this;
        self.$refs['EditFtieAssignModal'].show();
        if (default_obj) {
          self.ftie_assign_rule = JSON.parse(JSON.stringify(default_obj));
          if (action_type == 'Copy') {
            self.ftie_assign_rule.RULE_ID = null;
            _.set(self.ftie_assign_rule, 'action_type', 'Copy');
          } else {
            if (self.ftie_assign_rule.FTIE_SITE) {
              self.getFtieAssignOptionsBasedOnSite(self.ftie_assign_rule.FTIE_SITE);
            }
            _.set(self.ftie_assign_rule, 'action_type', 'Edit');
          }
          //self.getFtieAssignOptionsBasedOnSite(self.ftie_assign_rule.site);
        } else {
          self.ftie_assign_rule = JSON.parse(JSON.stringify(self.default_ftie_assign_rule));
          _.set(self.ftie_assign_rule, 'action_type', 'Add');
        }
      },
      getAssignOptions() {
        let self = this;
        let url = self.$root.baseUrl + '/admin-member/assign-rule-options/';
        console.log('####getPage######');

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        let ftie_assign_options;
        let request_data = {
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              ftie_assign_options = JSON.parse(res['ftie_assign_options']);
              if (res['ftie_assign_options']) {
                self.ftie_assign_options = ftie_assign_options;
              }
              console.log(ftie_assign_options)
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      getFtieAssignOptionsBasedOnSite(site) {
        let self = this;
        if (site && site !== 'IGNORE') {
          let url = self.$root.baseUrl + '/admin-member/assign-rule-detail-options/';

          const params = {
            token: encodeURI(self.$store.state.token),
            username: encodeURI(self.$store.state.username),
          };

          let ftie_assign_member_options;
          let request_data = {
            sf_company: self.ftie_assign_rule.SF_COMPANY,
            sf_sales_territory: self.ftie_assign_rule.SF_SALES_TERRITORY,
            gro: site
          };
          eventHub.$emit('loading', true);
          self.$axios.post(url, request_data, { params })
            .then((response) => {
              var res = response.data;
              //console.log(res);

              if (response.status === 200) {
                ftie_assign_member_options = JSON.parse(res['ftie_assign_member_options']);
                if (res['ftie_assign_member_options']) {
                  self.ftie_assign_options.customer_options = ftie_assign_member_options['customer_options'];
                  self.ftie_assign_options.gro_sa_options = ftie_assign_member_options['gro_sa_options'];
                  self.ftie_assign_options.contact_sales_options = ftie_assign_member_options['contact_sales_options'];
                }
                console.log(ftie_assign_member_options)
              }

              else if (response.status === 204) {
                self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
                console.log(res.description);
              }

              else if (res.description == "login") {
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                self.$axios.get(url)
                  .then((res) => {
                    console.log('logout');
                    self.$router.push("/");
                  })
                window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
              } else {
                self.$message.exception('Internal Server Error!');
                console.log(res.description);
              }
            }, (error) => {
              console.log(error);
              self.$message.exception('Internal Server Error!');
            })
            .finally(() => {
              eventHub.$emit('loading', false);
            })
        }
      },
      updateAssignRule(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        if (self.validateAssignRule()) {
          let url = self.$root.baseUrl + '/admin-member/add-update-assign-rule/';
          var i;
          const params = {
            token: encodeURI(self.$store.state.token),
            username: encodeURI(self.$store.state.username),
          };
          const request_data = {
            rule_obj: self.ftie_assign_rule
          };

          let action_success;
          eventHub.$emit('loading', true);
          self.$axios.post(url, request_data, { params })
            .then((response) => {
              var res = response.data;
              //console.log(res);

              if (response.status === 200) {
                action_success = JSON.parse(res['action_success']);
              }

              else if (response.status === 204) {
                self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
                console.log(res.description);
              }

              else if (res.description == "login") {
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                self.$axios.get(url)
                  .then((res) => {
                    console.log('logout');
                    self.$router.push("/");
                  })
                window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
              } else {
                self.$message.exception('Internal Server Error!');
                console.log(res.description);
              }
            }, (error) => {
              console.log(error);
              self.$message.exception('Internal Server Error!');
            })
            .finally(() => {
              eventHub.$emit('loading', false);
              self.$nextTick(() => {
                self.$refs['EditFtieAssignModal'].hide();
                self.getAssignRule();
                self.ftie_assign_rule = JSON.parse(JSON.stringify(self.default_ftie_assign_rule));
              })
            })

        }
      },
      getAssignRule() {
        let self = this;
        let url = self.$root.baseUrl + '/admin-member/get-assign-rule/';
        var i;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        let FtieAssignRules;
        eventHub.$emit('loading', true);
        self.$axios.post(url, {}, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              FtieAssignRules = JSON.parse(res['ftie_assign_rules']);
              self.FtieAssignRules = FtieAssignRules;
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      deleteAssignRule(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/admin-member/delete-assign-rule/';
        var i;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        const request_data = {
          rule_id: self.delete_rule_id
        };
        let FtieAssignRules;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              FtieAssignRules = JSON.parse(res['ftie_assign_rules']);
              self.FtieAssignRules = FtieAssignRules;
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.$nextTick(() => {
              self.$refs['DeleteAssignRuleModal'].hide();
              self.getAssignRule();
              self.ftie_assign_rule = JSON.parse(JSON.stringify(self.default_ftie_assign_rule));
            })
          })

      },
      validateAssignRule() {
        let self = this;
        let validate_empty = true;
        let missingColStr = '';
        if (!self.ftie_assign_rule.FTIE_SITE || !self.ftie_assign_rule.GTC_OWNER || !self.ftie_assign_rule.SF_COMPANY) {
          let warningMsg = `Please ensure you input the required columns in Assign Rule`
          self.$message.warning(`${warningMsg}`, 'Missing Required Fields');
          validate_empty = false;
        }
        return validate_empty;
      }
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MemberPage.vue